export default "__VITE_ASSET__DhIdYoD0__"